import {
  Component,
  OnInit,
  type ElementRef,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpClient } from '@angular/common/http';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'
};

@Component({
  selector: 'app-buyer-service-quote-list',
  templateUrl: './buyer-service-quote-list.component.html',
  styleUrls: ['./buyer-service-quote-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyerServiceQuoteListComponent implements OnInit {
  @ViewChild('supplierTable') table!: DatatableComponent;
  @ViewChild('archivedSection', { static: false }) archivedSection!: ElementRef;
  @ViewChild('heading', { static: false }) heading!: ElementRef;
  menuTrigger: MatMenuTrigger | null = null;

  showLoader: boolean = false;
  showDetailLoader: boolean = false;
  searchKeyword: string = '';
  userRole!: string;
  archivedLoaded: boolean = false;
  isBuyer: boolean | undefined;
  limit: number = 10;
  offset: number = 0;
  archivedLimit: number = 10;
  archivedOffset: number = 0;
  totalRecords: number = 0;
  archivedTotalRecords: number = 0;
  sortField: string = 'quotationSubmissionDate';
  sortDirection: string = 'DESC';
  docStatus: any;
  fromDate: any;
  toDate: any;
  masterSelected: boolean = false;
  isWrapDescription: boolean = false;
  documentData: any[] = [];
  AllQuotes: any;
  archivedDocumentData: any[] = [];
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedStatus: string = 'ALL';

  quoteTypeDropdownOpen: boolean = false;

  filterStatuses = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Pending', label: 'Quote' },
    { name: 'Rejected', label: 'Quote' },
    { name: 'ALL', label: 'Quote' },
  ];
  statusColors: { [key: string]: string } = {
    Accepted: '#1ebd60',
    Pending: '#ff9800',
    Rejected: '#FF0000',
  };
  activeIndex: number = this.filterStatuses.length - 1;

  rfqStatuses: any[] = [
    'Unactioned', 'Acknowledged', 'Quoted', 'Under Review',
    'Clarification Requested', 'Approved', 'Rejected', 'Awarded',
    'Closed', 'Open', 'In Review', 'Awaiting Supplier Response',
    'Canceled', 'Draft', 'Declined', 'Lost', 'Created',
  ];

  supplierUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;
  showProductPopUp: boolean = false;

  items = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  archivedItems = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  @ViewChild('rowDetailTpl', { static: true }) rowDetailTpl: TemplateRef<any> | undefined;
  quoteLineItemData: any[] = [];
  showProductReqCost: boolean = false;
  showQuoteReqCost: boolean = false;

  isChatOpen: boolean = false;
  headerData: any;
  userId!: number;

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup: boolean = false;
  selectedSupplier: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax: 'N/A'
  };

  expandedRowId: number | null = null;
  expandedRowIndex: number | null = null;
  private autoExpandDone: boolean = false;

  exchangeRatesCache: { [base: string]: any } = {};

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
  }

  operationType: string = 'buyerServiceQuote';

  async ngOnInit() {
    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      if (statusParam && labelParam) {
        this.selectedStatus = statusParam;
        this.docStatus = statusParam;
        this.setActiveStatus(statusParam, labelParam);
      } else {
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });

    if (this.userRole == 'Owner') {
      this.isBuyer = true;
    }

    await this.fetchAllDocuments();
  }

  // ===== FETCH ACTIVE DOCUMENTS =====
  async fetchAllDocuments() {
    this.operationType = 'buyerServiceQuote';
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      this.showLoader = true;
      this.fullLoaderService.showLoader();

      const response = await this.SettingsService.fetchAllServiceQuotesByBuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1, // isActive = 1 for active
        this.operationType
      );

      if (response && Array.isArray(response.rows)) {
        const enrichedRows = response.rows.map((rfq: any) => {
          const currentDate = new Date();
          const quotedByDate = new Date(rfq.quotedByDate);
          if (rfq.docStatus === 'Unactioned' && quotedByDate < currentDate) {
            rfq.docStatus = 'Expired';
          }
          if (this.expandedRowId === null) {
            this.expandedRowId = rfq.rfqId;
          }
          // Parse JSON fields if they come as strings
          if (typeof rfq.supplierQuotationList === 'string') {
            try { rfq.supplierQuotationList = JSON.parse(rfq.supplierQuotationList); } catch { rfq.supplierQuotationList = []; }
          }
          if (typeof rfq.buyerAttachments === 'string') {
            try { rfq.buyerAttachments = JSON.parse(rfq.buyerAttachments); } catch { rfq.buyerAttachments = []; }
          }
          if (typeof rfq.lineItemAttachments === 'string') {
            try { rfq.lineItemAttachments = JSON.parse(rfq.lineItemAttachments); } catch { rfq.lineItemAttachments = []; }
          }
          if (typeof rfq.rfqStatusStages === 'string') {
            try { rfq.rfqStatusStages = JSON.parse(rfq.rfqStatusStages); } catch { rfq.rfqStatusStages = []; }
          }
          // Parse nested supplier quotation list JSON fields
          if (Array.isArray(rfq.supplierQuotationList)) {
            rfq.supplierQuotationList.forEach((sq: any) => {
              if (typeof sq.quoteHeaderAttachments === 'string') {
                try { sq.quoteHeaderAttachments = JSON.parse(sq.quoteHeaderAttachments); } catch { sq.quoteHeaderAttachments = []; }
              }
              if (typeof sq.quoteLineItemAttachments === 'string') {
                try { sq.quoteLineItemAttachments = JSON.parse(sq.quoteLineItemAttachments); } catch { sq.quoteLineItemAttachments = []; }
              }
            });
          }
          rfq.statusesStages = this.buildRfqStages(rfq);
          rfq.statusesStages = this.buildOtherStages(rfq);
          return rfq;
        });

        this.documentData = enrichedRows;
        this.documentData = [...this.documentData];
        this.totalRecords = response.totalElements || 0;

        // Auto-expand first row
        if (!this.autoExpandDone && this.documentData.length > 0) {
          setTimeout(() => {
            try {
              const firstRow = this.documentData[0];
              this.expandedRowId = firstRow.rfqId;
              this.expandedRowIndex = 0;
              if (this.table && this.table.rowDetail) {
                try { this.table.rowDetail.collapseAllRows(); } catch {}
                this.table.rowDetail.toggleExpandRow(firstRow);
                this.autoExpandDone = true;
              }
            } catch (e) {
              console.warn('Auto-expand first row failed:', e);
            }
          }, 0);
        }
      }

      this.showLoader = false;
      this.fullLoaderService.hideLoader();
      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error fetching service quote documents', error);
      this.showLoader = false;
      this.fullLoaderService.hideLoader();
      this.cdr.markForCheck();
    }
  }

  // ===== FETCH ARCHIVED DOCUMENTS =====
  async fetchArchivedAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      const response = await this.SettingsService.fetchAllServiceQuotesByBuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.archivedLimit,
        this.archivedOffset,
        0, // isActive = 0 for archived
        'buyerServiceQuote'
      );

      if (response && Array.isArray(response.rows)) {
        const enrichedRows = response.rows.map((rfq: any) => {
          if (typeof rfq.supplierQuotationList === 'string') {
            try { rfq.supplierQuotationList = JSON.parse(rfq.supplierQuotationList); } catch { rfq.supplierQuotationList = []; }
          }
          if (typeof rfq.buyerAttachments === 'string') {
            try { rfq.buyerAttachments = JSON.parse(rfq.buyerAttachments); } catch { rfq.buyerAttachments = []; }
          }
          if (typeof rfq.lineItemAttachments === 'string') {
            try { rfq.lineItemAttachments = JSON.parse(rfq.lineItemAttachments); } catch { rfq.lineItemAttachments = []; }
          }
          if (Array.isArray(rfq.supplierQuotationList)) {
            rfq.supplierQuotationList.forEach((sq: any) => {
              if (typeof sq.quoteHeaderAttachments === 'string') {
                try { sq.quoteHeaderAttachments = JSON.parse(sq.quoteHeaderAttachments); } catch { sq.quoteHeaderAttachments = []; }
              }
              if (typeof sq.quoteLineItemAttachments === 'string') {
                try { sq.quoteLineItemAttachments = JSON.parse(sq.quoteLineItemAttachments); } catch { sq.quoteLineItemAttachments = []; }
              }
            });
          }
          rfq.statusesStages = this.buildRfqStages(rfq);
          rfq.statusesStages = this.buildOtherStages(rfq);
          return rfq;
        });

        this.archivedDocumentData = enrichedRows;
        this.archivedDocumentData = [...this.archivedDocumentData];
        this.archivedTotalRecords = response.totalElements || 0;
      }
      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error fetching archived service quote documents', error);
    }
  }

  // ===== FETCH ALL QUOTES (for export) =====
  async fetchAllQuotes() {
    try {
      this.operationType = 'buyerServiceQuote';
      const response = await this.SettingsService.fetchAllServiceQuotesByBuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        null,
        null,
        '',
        '',
        0,
        0,
        1,
        this.operationType
      );
      if (response && Array.isArray(response.rows)) {
        this.AllQuotes = response.rows;
      }
    } catch (error) {
      console.error('Error fetching all service quotes:', error);
      throw error;
    }
  }

  // ===== TOGGLE DROPDOWN =====
  toggleQuoteTypeDropdown() {
    this.quoteTypeDropdownOpen = !this.quoteTypeDropdownOpen;
  }

  navigateToQuoteType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/buyer-quote-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/buyer-service-quote-list']);
    }
  }

  // ===== STATUS / FILTER =====
  setActiveStatus(status: string, label: string) {
    const index = this.filterStatuses.findIndex(
      (s) => s.name === status && s.label === label
    );
    if (index !== -1) {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.docStatus = status;
    } else {
      this.docStatus = 'ALL';
      this.selectedStatus = 'ALL';
    }
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000';
  }

  onStatusSelect(status: string, index: number, label: string) {
    if (this.selectedStatus.includes(status)) return;
    if (label === 'Quote') {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      this.fetchAllDocuments();
    }
  }

  // ===== DATE / FORMAT =====
  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment();
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
    else if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;
    else if (diffInHours < 24) return `${diffInHours} hours ago`;
    else if (diffInDays === 1) return 'Yesterday';
    else return moment(rfqDate).format('DD MMM YYYY');
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  isRFQExpired(quotedByDate: string | Date): boolean {
    if (!quotedByDate) return false;
    return new Date() > new Date(quotedByDate);
  }

  // ===== ROW EXPAND =====
  toggleExpandRow(row: any, index: number) {
    const clickedId = row?.rfqId;
    const isSameRow = this.expandedRowId === clickedId;

    if (this.table && this.table.rowDetail) {
      try { this.table.rowDetail.collapseAllRows(); } catch {}
    }

    if (isSameRow) {
      this.expandedRowId = null;
      this.expandedRowIndex = null;
      return;
    }

    this.expandedRowId = clickedId;
    this.expandedRowIndex = index;

    if (this.table && this.table.rowDetail) {
      this.table.rowDetail.toggleExpandRow(row);
    }
  }

  getRowHeight = (row: any): number => {
    if (this.expandedRowId !== undefined) {
      const expandedRow = this.documentData.find(r => r.rfqId === this.expandedRowId);
      if (expandedRow) {
        const itemCount = expandedRow?.supplierQuotationList?.length || 0;
        if (itemCount === 0) return 266;
        else if (itemCount > 3) return 480;
        else return itemCount * 120 + 266;
      }
    }
    return 100;
  };

  setRowClass = (row: any) => 'green-row-background';
  rowIdentity = (row: any) => row.rfqId;

  // ===== PAGINATION / SORT / SEARCH =====
  onPageChange(event: any) {
    this.offset = event.offset;
    this.selectedRfq = [];
    this.fetchAllDocuments();
  }

  onSearch() {
    this.offset = 0;
    this.fetchAllDocuments();
  }

  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchArchivedAllDocuments();
  }

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset;
    this.fetchArchivedAllDocuments();
  }

  // ===== COLUMNS =====
  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateArchivedSelectedColumns();
  }

  updateSelectedColumns() {
    this.selectedColumns = this.items
      .filter(item => item.selected)
      .map(item => ({ label: item.label, prop: item.prop }));
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter(item => item.selected)
      .map(item => ({ label: item.label, prop: item.prop }));
  }

  // ===== CHECKBOX SELECTION =====
  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    if (section == 'active') {
      this.selectedRfq = checked ? this.documentData.map(item => item.quoteId) : [];
    } else {
      this.selectedArchivedRfq = checked ? this.archivedDocumentData.map(item => item.quoteId) : [];
    }
  }

  selectDeselectRfq(event: any, supplierRfqDetailsId: any, quoteId: any, section: string, owner: any) {
    const checked = event.target.checked;
    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(quoteId);
        if (owner !== null) {
          this.snack.open(`User is already assigned to Quote ID ${quoteId}`, 'OK', { duration: 5000 });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter(id => id !== quoteId);
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(quoteId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(id => id !== quoteId);
      }
    }
  }

  isChecked(quoteId: number, section: string) {
    return section == 'active'
      ? this.selectedRfq.includes(quoteId)
      : this.selectedArchivedRfq.includes(quoteId);
  }

  // ===== ARCHIVE / UNARCHIVE =====
  rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select at least one', 'OK', { duration: 3000 });
        return;
      }
      const unarchivedIds = new Set(this.selectedArchivedRfq);
      const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.quoteId));
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.quoteId));
      this.documentData = [...toUnarchive, ...this.documentData];
      this.totalRecords += toUnarchive.length;
      this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      this.selectedArchivedRfq = [];
      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else if (operation == 'archive') {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select at least one.', 'OK', { duration: 3000 });
        return;
      }
      const archivedIds = new Set(this.selectedRfq);
      const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.quoteId));
      this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.quoteId));
      this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
      this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);
      this.archivedTotalRecords += toArchive.length;
      this.selectedRfq = [];
      this.snack.open('Items archived', 'OK', { duration: 3000 });
    }
    this.documentData = [...this.documentData];
    this.archivedDocumentData = [...this.archivedDocumentData];
    this.cdr.markForCheck();
  }

  restore(quoteId: number, operation: string) {
    if (operation == 'unArchive') {
      const idx = this.archivedDocumentData.findIndex((r: any) => r.quoteId === quoteId);
      if (idx !== -1) {
        const [row] = this.archivedDocumentData.splice(idx, 1);
        this.documentData = [row, ...this.documentData];
        this.totalRecords += 1;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);
      }
      this.documentData = [...this.documentData];
      this.archivedDocumentData = [...this.archivedDocumentData];
      this.snack.open('Item unarchived', 'OK', { duration: 3000 });
      this.cdr.markForCheck();
    }
  }

  // ===== EXPORT =====
  async exportAllQuotes() {
    try {
      this.fullLoaderService.showLoader('Exporting Service Quote Details...');
      await this.fetchAllQuotes();

      if (!this.AllQuotes || this.AllQuotes.length === 0) {
        this.snack.open('No Service Quotes available to export.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
        return;
      }
      // Export logic will be implemented later
      this.snack.open('Export All - export logic coming soon', 'OK', { duration: 3000 });
      this.fullLoaderService.hideLoader();
    } catch (error) {
      console.error('Error exporting service quotes:', error);
      this.fullLoaderService.hideLoader();
    }
  }

  // ===== TOGGLE ARCHIVED =====
  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand && !this.archivedLoaded) {
      this.archivedLoaded = true;
      this.fetchArchivedAllDocuments();
    }
    if (this.isArchivedExpand && this.heading) {
      this.heading.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = 'ALL';
    this.docStatus = 'ALL';
    this.fetchAllDocuments();
  }

  // ===== USER ASSIGNMENT =====
  async toggleUserSelection(item: any) {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Quote before selecting a user.', 'OK', { duration: 3000 });
      return;
    }
    item.selected = !item.selected;
    if (item.selected) {
      this.snack.open('User assigned to Quote (dummy).', 'OK', { duration: 3000 });
      item.selected = false;
    }
  }

  onScroll(): void {}

  async fetchUsers(): Promise<void> {
    this.supplierUsersList = [
      { id: 1, firstName: 'John Doe', selected: false },
      { id: 2, firstName: 'Jane Smith', selected: false },
      { id: 3, firstName: 'Bob Johnson', selected: false },
    ];
  }

  async onUserMenuOpened() {
    if (!this.supplierUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
  }

  // ===== LINE ITEM POPUP =====
  fetchQuoteLineItemDetailsByQuoteId(quoteId: number) {
    this.showDetailLoader = true;
    this.showProductPopUp = true;
    // Line item detail fetch will be implemented with a separate SP operation later
    this.quoteLineItemData = [];
    this.showDetailLoader = false;
    this.cdr.markForCheck();
  }

  toggleSidebar(value: boolean, section?: string) {
    if (!value) this.quoteLineItemData = [];
    this.showProductPopUp = value;
  }

  toggleShowColumn(section: string) {
    if (section == 'productCost') this.showProductReqCost = !this.showProductReqCost;
    else if (section == 'quoteCost') this.showQuoteReqCost = !this.showQuoteReqCost;
  }

  // ===== NAVIGATION =====
  openRfqDetails(rfqId: number) {
    this.snack.open(`Open service RFQ details: ${rfqId} (not implemented)`, 'OK', { duration: 2000 });
  }

  viewQuotePreview(quoteId: number, supplierId: number, rfqId: number) {
    this.snack.open(`View service quote preview: ${quoteId} (not implemented)`, 'OK', { duration: 2000 });
  }

  // ===== DOWNLOAD / PRINT =====
  downloadRfqForBuyer(refNo: string, row: any) {
    this.snack.open(`Download RFQ PDF: ${refNo} (not implemented)`, 'OK', { duration: 2000 });
  }

  downloadQuote(row: any, supplier: any) {
    this.snack.open(`Download Quote PDF: ${supplier.quoteRefNumber} (not implemented)`, 'OK', { duration: 2000 });
  }

  generateRFQExcelForBuyer(rfqId: number) {
    this.snack.open(`Download RFQ Excel: ${rfqId} (not implemented)`, 'OK', { duration: 2000 });
  }

  generateQuoteExcel(quoteId: number, rfqId: number, supplierId: number, ref: string) {
    this.snack.open(`Download Quote Excel: ${ref} (not implemented)`, 'OK', { duration: 2000 });
  }

  // ===== PREVIEW / CONTACT =====
  togglePreview(value: boolean, section: string, row?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (row && section == 'rfq') {
      this.previewDocs = [...(row.buyerAttachments || []), ...(row.lineItemAttachments || [])];
    } else if (row && section == 'quote') {
      this.previewDocs = [...(row.quoteHeaderAttachments || []), ...(row.quoteLineItemAttachments || [])];
    }
  }

  toggleContactPopUp(value: boolean, row?: any) {
    this.showContactPopup = value;
    if (value && row) {
      this.selectedSupplier = {
        companyName: row.supplierName,
        contactPerson: row.supplierContact,
        email: row.supplierEmail,
        phone: row.supplierPhone,
        address: row.supplierAddress,
        fax: row.supplierFax
      };
    }
  }

  // ===== CHAT =====
  openChat(rfq: any, supplier: any) {
    this.headerData = {
      rfqId: rfq.rfqId,
      rfqDate: rfq.rfqDate,
      rfqRefNumber: rfq.rfqRefNumber,
      vesselName: rfq.vesselName,
      vesselImoNumber: rfq.vesselImoNumber,
      portName: rfq.portName,
      vesselEta: rfq.vesselEta,
      vesselEtd: rfq.vesselEtd,
      buyerId: rfq.buyerId || Number(this.cookieService.get('userId')),
      supplierId: supplier.supplierId,
    };
    this.isChatOpen = true;
  }

  closeChat() {
    this.isChatOpen = false;
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  // ===== CURRENCY CONVERSION =====
  getConvertedAmount(supplier: any, buyerCurrency: string): string {
    const amount = supplier.totalReqCost;
    if (!amount) return 'N/A';
    if (!this.isWrapDescription) return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    const supplierCurrency = supplier.quoteCurrency || 'EUR';
    if (!supplierCurrency) return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    const rates = this.exchangeRatesCache[buyerCurrency];
    if (rates && rates[supplierCurrency]) {
      const converted = (amount * rates[supplierCurrency]).toFixed(3);
      return `${supplierCurrency} ${converted}`;
    }
    return `${buyerCurrency} ${amount}`;
  }

  toggleWrapDescription(event: any, row: any, section: string) {
    if (section == 'quote') {
      this.showQuoteReqCost = event.checked;
      const baseCurrency = row.rfqReqCurrencyCode;
      if (!baseCurrency) {
        this.snack.open('Buyer does not have a currency code', 'Close', { duration: 4000 });
        return;
      }
      if (!this.exchangeRatesCache[baseCurrency]) {
        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        this.http.get(url).subscribe(
          (res: any) => {
            if (res.result === 'success') {
              this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
            }
          },
          (error: any) => {
            if (error && error.status === 429) {
              this.snack.open('Currency exchange API limit exceeded.', 'OK', { duration: 7000 });
            }
          }
        );
      }
    } else {
      this.showProductReqCost = event.checked;
    }
  }

  // ===== TIMELINE / STAGES =====
  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const rfqStagesList = [
      { name: 'Unactioned', heading: 'RFQ Sent:' },
      { name: 'Expired', heading: 'RFQ Expired:' },
      { name: 'Draft', heading: 'RFQ Drafted:' },
      { name: 'Canceled', heading: 'RFQ Canceled:' },
      { name: 'Created', heading: 'RFQ Created:' },
    ];
    const quoteStagesList = [
      { name: 'Accepted', heading: 'Quotation Recieved' },
      { name: 'Declined', heading: 'Quotation Declined:' },
      { name: 'Draft', heading: 'Quotation Drafted:' },
      { name: 'Quoted', heading: 'Quotation Recieved' },
      { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
    ];
    const list = entityType === 'RFQ' ? rfqStagesList : quoteStagesList;
    const match = list.find(stage => stage.name.toLowerCase() === label.toLowerCase());
    return match ? match.heading : label;
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined' || row.docStatus === 'Canceled') return 'stage-declined';
    switch (label) {
      case 'Declined': return 'stage-declined';
      case 'Expired': return 'stage-lapsed';
      default: return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  buildRfqStages(rfq: any) {
    const rfqStatusName = this.rfqStatuses[rfq.rfqStatus - 1];
    rfq.docStatus = rfqStatusName;

    const stagesArray: any[] = [];

    stagesArray.push({
      heading: this.getHeadingFromLabel('Created', 'RFQ'),
      label: 'RFQ Created',
      date: this.formatRfqDate(rfq.rfqDate),
      completed: true,
    });

    stagesArray.push({
      heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
      label: `RFQ Sent(${rfq.rfqSupplierCount})`,
      date: this.formatDate(rfq.rfqDate),
      completed: true,
    });

    if (rfq.docStatus === 'Unactioned' && this.isRFQExpired(rfq.quotedByDate)) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Expired', 'RFQ'),
        label: 'RFQ Expired',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];
    let quoteCount = rfq.supplierQuotationList?.length || 0;

    if (quoteCount > 0) {
      const lastQuotationDate = rfq.supplierQuotationList[quoteCount - 1]?.quotationDate;
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quoted', 'Quote'),
        label: `Quotation Received(${quoteCount})`,
        date: lastQuotationDate ? this.formatDate(lastQuotationDate) : '',
        completed: true,
      });
    } else {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quoted', 'Quote'),
        label: 'Quotation Received(0)',
        date: '',
        completed: false,
      });
    }

    stagesArray.push({ heading: 'PO Created', label: 'PO Created', date: '', completed: false });
    stagesArray.push({ heading: 'PO Confirmation', label: 'PO Confirmation', date: '', completed: false });
    stagesArray.push({ heading: 'Delivered Onboard', label: 'Delivered', date: '', completed: false });

    return stagesArray;
  }

  getRemainingTime(row: any): { label: string; color: string; tooltip: string } {
    if (!row.quotedByDate) return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) return { label: 'New', color: '#0BA716', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays >= 4) return { label: 'Standard', color: '#FD8900', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays >= 1) return { label: 'Urgent', color: '#F60303', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays < 0) return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
    else return { label: 'Urgent', color: '#F60303', tooltip: 'Due today' };
  }
}
